// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"1577":"23fd1127","1958":"c76c3ded","2589":"d58c8f4e","5587":"a544d438","7031":"91518193"}[chunkId] + ".css";
};